import React, { useContext, useEffect, useRef, useState } from "react";
import "./styles.css";
import PATHS from "../../Routes/paths";
import { Breadcrumb, Title } from "../../Components/Atoms";
import { StoreContext } from "../../Library/contexts";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { getRoutes } from "../../APIs";

const ViewRoutes = () => {
  const [ routes, setRoutes ] = useState([]);
  const [ triggers, setTriggers ] = useState([]);
  const { userVehicles, allVehicleRoutes, setAllVehicleRoutes, setRoutesGeofenceMap, routeTriggers, setRouteTriggers } = useContext(StoreContext);
  const userVehMap = useRef({});
  const geofenceMap = useRef({});

  const navigate = useNavigate();

  const breadcrumbPaths = [
    { idx: 1, name: "View Routes", isCurrentPage: true },
  ];

  const fetchRoutes = (vehicleMap) => {
    getRoutes((err, data) => {
      if (err) console.error(err);
      else {
        if (data.triggers && data.triggers.length) {
          data.triggers.forEach(fence => {
            geofenceMap.current[fence.idx] = fence;
          });
          setRoutesGeofenceMap(geofenceMap.current);
          setTriggers(data.triggers);
          setRouteTriggers(data.triggers);
        }

        if (data.vehRoutes && data.vehRoutes.length) {
          data.vehRoutes.forEach(route => {
            let vehicles = route.vids.map(id => vehicleMap.current[id] && vehicleMap.current[id].reg ? vehicleMap.current[id].reg : "").filter(model => model !== "");
            route.vehicles = vehicles;
            let fences = route.trgIds.map(id => geofenceMap.current[id] && geofenceMap.current[id].title ? geofenceMap.current[id].title : "").filter(title => title !== "");
            route.fences = fences;
          });
          setRoutes(data.vehRoutes);
          setAllVehicleRoutes(data.vehRoutes);
        }
      }
    });
  }

  useEffect(() => {
    if (!userVehicles || !userVehicles.length) return;

    userVehicles.forEach(vehicle => {
      userVehMap.current[vehicle.idx] = vehicle;
    });

    if (routeTriggers && routeTriggers.length && allVehicleRoutes && allVehicleRoutes.length) {
      setTriggers(routeTriggers);
      setRoutes(allVehicleRoutes);
      return;
    }

    if ((!triggers || !triggers.length || !routes || !routes.length)) fetchRoutes(userVehMap);
  }, [ userVehicles, routes, triggers ]);

  return (
    <section className="panel-main view-routes">
      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className="routes-page">
        <>
          <div className="routes-page-header">
            <Title fixed>All Routes</Title>
            <Button className="set-route-btn" onClick={() => navigate(`${PATHS.VIEW_ROUTES}${PATHS.SET_ROUTES}?fromAlerts=${true}`)}>
              Add Routes
            </Button>
          </div>
          {routes && routes.length ? <div className="routes-list-container">
            {routes.map(route => {
              return (
                <div key={route.idx} className="route-card">
                  <Button onClick={() => navigate(`${PATHS.VIEW_ROUTES}/${PATHS.VIEW_STATS}?idx=${route.idx}`)} className="view-stats-btn">View Stats</Button>
                  <div className="title">
                    Title:
                    <div className="title-block">
                      {route.nm || ""}
                    </div>
                  </div>
                  <div className="vehicles">
                    Vehicles:
                    <div className="vehicle-blocks">
                      {route.vehicles.map((veh, idx) => <div key={idx} className="veh-box">{veh}</div>)}
                    </div>
                  </div>
                  <div className="fences">
                    Geofences:
                    <div>
                      {route.fences.map((fen, idx) => <div key={idx} className="fen-box">{fen}</div>)}
                    </div>
                  </div>
                </div>
              )
            })}
          </div> : <div className="empty-route-list">You haven't added any routes yet</div>}
        </>
      </div>
    </section>
  )
}

export default ViewRoutes
